import type { ReactNode } from "react";
import { cn } from "./cn.js";

type Props = {
  title?: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  className?: string;
  bodyClassName?: string;
  children: ReactNode;
};

/** Subtle, low-contrast card. Linear-style — minimal chrome, generous
 *  padding, no garish stripes. */
export function Card({
  title,
  subtitle,
  action,
  className,
  bodyClassName,
  children,
}: Props) {
  return (
    <section
      data-anchor={typeof title === "string" ? `card:${title}` : undefined}
      className={cn(
        "flex flex-col rounded-lg border border-border bg-surface-muted/60",
        "shadow-[0_1px_0_0_var(--p-hi)_inset]",
        className,
      )}
    >
      {(title || action) && (
        <header className="flex items-start justify-between gap-3 px-5 py-3.5 border-b border-divider">
          <div className="min-w-0">
            {title && (
              <h3 className="text-[15px] font-semibold text-ink tracking-[-0.01em]">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-[12px] text-ink-muted mt-0.5">{subtitle}</p>
            )}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </header>
      )}
      <div className={cn("flex-1 p-5", bodyClassName)}>{children}</div>
    </section>
  );
}
